// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cross-record-result-dialog.common-dialog[data-v-395d121c] .el-dialog{width:var(--common-dialog-large-width)}.cross-record-result-dialog.common-dialog .el-descriptions[data-v-395d121c]{margin-bottom:var(--base-size-24)}", ""]);
// Exports
module.exports = exports;
